import dayjs from 'dayjs';

export const parseAndFormatDateForGraph = (dateString: string) => {
  return dayjs.tz(dateString).format('L HH:mm:ss');
};

export const parseAndFormatDateForMobileGraph = (dateString: string) => {
  return dayjs.tz(dateString).format('HH:mm');
};
